// namespace Pacem {
export class Numbers {
    static round(x, step = 1.0) {
        return Math.round(x / step) * step;
    }
    static log(x, base) {
        return Math.log10(x) / Math.log10(base);
    }
    static rebase(v, from, to) {
        const vStr = v.toString();
        const firstPass = parseInt(vStr, from);
        if (!vStr.endsWith(firstPass.toString(from))) {
            return Number.NaN.toString();
        }
        return parseInt(v.toString(), from).toString(to);
    }
}
//}
